import { Entity } from '@adornis/baseql/decorators.js';
import { AdornisFile } from '@adornis/file-utils/db/files.js';

/**
 * @entity BuddyMailAttachment
 */
@Entity()
export class BuddyMailAttachment extends AdornisFile {
  static override _class = 'BuddyMailAttachment';
}
